<template>
  <es-loader v-if="loading" style="margin: 15rem"/>
  <es-exception v-else-if="loadingError"
    style="padding: 15rem"
    margin="0rem" size="4x"
    exceptionMessage="There was an issue. Please try again or contact your administrator."
  />
  <div v-else-if="viewDupGroupDetails" class="document-container">
    <div class="columns is-desktop">
      <div class="column">
        <duplicate-group-details
          @backToDupQueue="backToGroupDetails"
          @idToMerge="idToMergeInfo($event)"
          @idToRetire="idToRetireInfo($event)"
          @goBack="backToGroupsList"
          @viewComparePage="viewComparePageDetails"
          :queueId="queueId"
          :groupId="groupId"
          :dupGroupDetails="dupGroupDetails"
          :searchType="userSelectedSearch"
          :personTypeQueue="personTypeQueue"
        />
      </div>
      <div class="column is-3">
        <retire-merge-id-summary
          :mergeId="mergeId"
          :retireId="retireId"
        />
        <quick-tips-duplicate-group-details style="margin-top: 1rem"/>
      </div>
    </div>
  </div>
  <div v-else-if="viewRetireMergeIdDetails" class="document-container">
    <div v-if="!viewConfirmationPage">
      <id-manager-info-panel
        v-if="!retiredConfirmation"
        style="margin-bottom: 1rem"
        @returnToList="cancelToList"
        @returnToDetails="cancelToDetails"
        :page="'comparePage'"
        :retiredConfirmation="retiredConfirmation"
        :loadingIdError="loadingIdError"
        :loadingIdErrorMsg="loadingIdErrorMsg"
        :retirePerson="retireId"
        :retirePendingNearMatchTransactions="retirePendingNearMatchTransactions"
      />
      <id-manager-info-panel
        v-if="retiredConfirmation"
        style="margin-bottom: 1rem"
        @returnToList="backToGroupsList"
        @returnToDetails="cancelToDetails"
        :mergePerson="mergePerson"
        :page="'comparePage'"
        :retiredConfirmation="retiredConfirmation"
        :retirePerson="retirePerson"
        :retiredResult="retiredResult"
      />
      <div class="columns is-desktop">
        <div class="column">
          <review-retire-merge-id-details
            @viewRetireMergeConfirmationPage="showConfirmationPage"
            @retirePersonToConfirmationPage="storeRetirePerson($event)"
            @mergePersonToConfirmationPage="storeMergePerson($event)"
            @groupInfo="loadGroupDetails($event); backToGroupDetails()"
            :queueId="queueId"
            :groupId="groupId"
            :retirePerson="retirePerson"
            :retirePersonHistInfo="retirePersonHistInfo"
            :retirePersonLocInfo="retirePersonLocInfo"
            :mergePerson="mergePerson"
            :mergePersonHistInfo="mergePersonHistInfo"
            :mergePersonLocInfo="mergePersonLocInfo"
            :idToMerge="mergeId"
            :idToRetire="retireId"
            :retiredConfirmation="retiredConfirmation"
            :retiredResult="retiredResult"
            :hasRetireIdMergePermission="hasRetireIdMergePermission"
            :hasRetireIdNoMergePermission="hasRetireIdNoMergePermission"
          />
        </div>
        <div class="column is-3">
          <quick-tips-review-retire-merge-id-details
            :retiredConfirmation="retiredConfirmation"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <id-manager-info-panel
        @returnToDetails="cancelToDetails"
        :page="'confirmPage'"
        :retirePerson="retirePerson"
        :mergePerson="mergePerson"
        style="margin-bottom: 1rem"
      />
      <div class="columns is-desktop">
        <div class="column">
          <review-retire-merge-confirmation
            @showRetireConfirmedPage="storeRetiredResult($event)"
            @cancelToList="cancelToList"
            @cancelToDetails="cancelToDetails"
            @backToComparePage="showConfirmationPage"
            @groupInfo="loadGroupDetails($event)"
            :retirePerson="retirePerson"
            :retirePersonHistInfo="retirePersonHistInfo"
            :mergePerson="mergePerson"

          />
        </div>
        <div class="column is-3">
          <quick-tips-review-retire-merge-confirmation/>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="document-container">
    <div class="columns is-desktop">
      <div class="column">
        <duplicate-search
          @dupFields="storeDupFields($event)"
          @dupQueueResults="storeQueueResults($event)"
          @loadingQueue="setLoadingQueue($event)"
          @loadingErrorQueue="setLoadingErrorQueue($event)"
          @loadingSession="setLoadingSession($event)"
          @loadingErrorSession="setLoadingErrorSession($event)"
          @sendPersonTypeQueue="storePersonTypeQueue($event)"
          @sendPersonTypeSession="storePersonTypeSession($event)"
          @searchSelected="searchType($event)"
          @sessionFields="storeSessionFields($event)"
          @sessionResults="storeSessionResults($event)"
        />
      </div>
      <div class="column is-3">
        <quick-tips-duplicate-search/>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <search-results
          @groupInfo="storeGroupInfo($event)"
          :dupFields="dupFields"
          :loadingQueue="loadingQueue"
          :loadingErrorQueue="loadingErrorQueue"
          :loadingSession="loadingSession"
          :loadingErrorSession="loadingErrorSession"
          :queueResultsStored="queueResultsStored"
          :searchType="userSelectedSearch"
          :sessionFields="sessionFields"
          :sessionResultsStored="sessionResultsStored"
          :personTypeQueue="personTypeQueue"
          :personTypeSession="personTypeSession"
        />
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faExclamationCircle,
} from '@fortawesome/pro-solid-svg-icons';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import DuplicateGroupDetails from '@/components/ID Manager Components/DuplicateGroupDetails.vue';
import DuplicateSearch from '@/components/ID Manager Components/DuplicateSearch.vue';
import IdManagerInfoPanel from '@/components/ID Manager Components/IdManagerInfoPanel.vue';
import QuickTipsDuplicateGroupDetails from '@/components/ID Manager Components/QuickTipsDuplicateGroupDetails.vue';
import QuickTipsDuplicateSearch from '@/components/ID Manager Components/QuickTipsDuplicateSearch.vue';
import QuickTipsReviewRetireMergeIdDetails from '@/components/ID Manager Components/QuickTipsReviewRetireMergeIdDetails.vue';
import QuickTipsReviewRetireMergeConfirmation from '@/components/ID Manager Components/QuickTipsReviewRetireMergeConfirmation.vue';
import RetireMergeIdSummary from '@/components/ID Manager Components/RetireMergeIdSummary.vue';
import ReviewRetireMergeIdDetails from '@/components/ID Manager Components/ReviewRetireMergeIdDetails.vue';
import ReviewRetireMergeConfirmation from '@/components/ID Manager Components/ReviewRetireMergeConfirmation.vue';
import SearchResults from '@/components/ID Manager Components/SearchResults.vue';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faExclamationCircle,
);

export default {
  mixins: [
    PermissionManager,
  ],
  components: {
    DuplicateGroupDetails,
    DuplicateSearch,
    EsException,
    EsLoader,
    IdManagerInfoPanel,
    QuickTipsDuplicateGroupDetails,
    QuickTipsDuplicateSearch,
    QuickTipsReviewRetireMergeIdDetails,
    QuickTipsReviewRetireMergeConfirmation,
    RetireMergeIdSummary,
    ReviewRetireMergeIdDetails,
    ReviewRetireMergeConfirmation,
    SearchResults,
  },
  data() {
    return {
      dupFields: null,
      dupGroupDetails: null,
      group: null,
      groupId: null,
      loading: false,
      loadingError: false,
      loadingErrorSession: false,
      loadingErrorQueue: false,
      loadingSession: false,
      loadingQueue: false,
      mergeId: null,
      mergePerson: null,
      mergePersonHistInfo: null,
      mergePersonLocInfo: null,
      personTypeQueue: null,
      personTypeSession: null,
      retireId: null,
      retirePerson: null,
      retirePersonHistInfo: null,
      retirePersonLocInfo: null,
      retiredConfirmation: false,
      retiredResult: null,
      sessionFields: null,
      queueId: null,
      queueResultsStored: null,
      sessionResultsStored: null,
      userSelectedSearch: this.$route.query.search,
      viewConfirmationPage: false,
      viewDupGroupDetails: false,
      viewRetireMergeIdDetails: false,
      hasRetireIdMergePermission: true,
      hasRetireIdNoMergePermission: true,
      loadingIdError: false,
      loadingIdErrorMsg: null,
      retirePendingNearMatchTransactions: [],
    };
  },
  async created() {
    await this.loadPersonTypes();
    this.reRunSessionQuery();
  },
  computed: {
    ...mapGetters('lookups', [
      'defaultPersonType',
    ]),
    ...mapGetters([
      'userDistricts',
      'userPersonTypes',
      'userSchools',
    ]),
    setOfUserDistricts() {
      return this.userDistricts.map(a => a.code);
    },
    setOfUserPersonTypes() {
      return this.userPersonTypes.map(a => a.code);
    },
    setOfUserSchools() {
      return this.userSchools.map(a => a.code);
    },
    searchParams() {
      return this.paramsSerializer(this.urlParams);
    },
    urlParams() {
      const sessionFields = JSON.parse(localStorage.getItem('SESSION_DUP_QUEUE_FIELDS'));
      const sessionPersonType = JSON.parse(localStorage.getItem('SESSION_DUP_QUEUE_PERSONTYPE'));

      const params = {
        search: 'session',
        requestType: 'ON_DEMAND',
        fields: sessionFields.map(s => s.code),
        page: this.$route.query.page || 1,
        sort: '[{"field":"count","order":"DESC"}]',
      };
      if (sessionPersonType != null) {
        params.personType = sessionPersonType;
      }
      return params;
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadPersonTypes',
    ]),
    backToGroupDetails() {
      this.loadGroupDetails();
      this.viewConfirmationPage = false;
      this.viewDupGroupDetails = true;
      this.viewRetireMergeIdDetails = false;
    },
    backToGroupsList() {
      this.clearOutPreviousData();
      this.viewConfirmationPage = false;
      this.viewDupGroupDetails = false;
      this.viewRetireMergeIdDetails = false;
      if (this.$route.query.search === 'session') {
        this.reRunSessionQuery();
      }
    },
    cancelToList() {
      this.clearOutPreviousData();
      this.loadGroupDetails();
      this.viewDupGroupDetails = true;
      this.viewRetireMergeIdDetails = false;
      this.viewConfirmationPage = false;
    },
    cancelToDetails() {
      this.showConfirmationPage();
    },
    clearOutPreviousData() {
      this.mergePerson = null;
      this.mergeId = null;
      this.retirePerson = null;
      this.retireId = null;
      this.retiredConfirmation = false;
      this.retiredResult = null;
    },
    idToRetireInfo(id) {
      this.retireId = id;
    },
    idToMergeInfo(id) {
      this.mergeId = id;
    },
    newDupQueue() {
      this.$router.replace({ query: this.urlParams });
      return axios.post(`idmanager/duplicates?${this.searchParams}`);
    },
    paramsSerializer(params) {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
    async reRunSessionQuery() {
      try {
        this.loadingSession = true;
        this.loadingErrorSession = false;
        const response = await this.newDupQueue();
        if (response.status === 200) {
          this.sessionResultsStored = response.data.groups;
          this.personTypeSession = this.personType;
        }
      } catch (e) {
        this.loadingErrorSession = true;
      } finally {
        this.loadingSession = false;
      }
    },
    storeGroupInfo(data) {
      this.group = data;
      if (this.userSelectedSearch === 'queue') {
        this.groupId = data.id;
        this.queueId = data.queueId;
        localStorage.setItem('GROUP_ID', JSON.stringify(this.groupId));
      }
      this.loadGroupDetails();
    },
    async loadGroupDetails() {
      this.loading = true;
      this.loadingError = false;
      if (this.userSelectedSearch === 'session') {
        this.group.group.PERSON_TYPE = JSON.parse(localStorage.getItem('SESSION_DUP_QUEUE_PERSONTYPE'));
        if (this.group.group.PERSON_TYPE === null) {
          delete this.group.group.PERSON_TYPE;
        }
        // Queue ID and Group ID has to be a numeric value for the Session search of Duplicate Queue
        this.queueId = -1;
        this.groupId = -1;
      }
      try {
        const response1 = await axios({
          method: 'post',
          url: `/idmanager/duplicates/${this.queueId}/groups/${this.groupId}/details/data`,
          data: {
            group: this.group.group,
            type: this.group.type,
          },
        });
        const sessionArray = response1.data.details;
        this.dupGroupDetails = sessionArray;
        if (this.userSelectedSearch === 'queue') {
          const queueArray = [];
          const response2 = await axios({
            method: 'get',
            url: `/idmanager/duplicates/${this.queueId}/groups/${this.groupId}/details`,
          });
          sessionArray.forEach((element) => {
            const temp = response2.data.find(a => a.personId === element.personId);
            if (temp) {
              temp.activeHistoryCount = element.student.activeHistoryCount;
              queueArray.push(temp);
            }
          });
          this.dupGroupDetails = queueArray;
        }
      } catch (e) {
        this.loadingError = true;
      } finally {
        this.loading = false;
        this.viewDupGroupDetails = true;
      }
    },
    searchType(type) {
      this.userSelectedSearch = type;
    },
    setLoadingQueue(value) {
      this.loadingQueue = value;
    },
    setLoadingErrorQueue(value) {
      this.loadingErrorQueue = value;
    },
    setLoadingSession(value) {
      this.loadingSession = value;
    },
    setLoadingErrorSession(value) {
      this.loadingErrorSession = value;
    },
    showConfirmationPage() {
      this.viewConfirmationPage = !this.viewConfirmationPage;
    },
    storeDupFields(data) {
      const parsedData = JSON.parse(data);
      this.dupFields = parsedData.fields;
    },
    storePersonTypeQueue(data) {
      this.personTypeQueue = data;
    },
    storePersonTypeSession(data) {
      this.personTypeSession = data;
    },
    storeQueueResults(data) {
      this.queueResultsStored = data;
    },
    storeRetirePerson(data) {
      this.retirePerson = data;
    },
    async storeRetiredResult(result) {
      this.loading = true;
      this.loadingError = false;
      this.retiredConfirmation = true;
      this.retiredResult = result;
      try {
        const retireResults = await axios.get(`retired-person/${result.reference.idRetired}/profile`);
        this.retirePerson = retireResults.data;
        const temp = await axios.get(`retired-person/${result.reference.idRetired}/location`);
        /* eslint-disable */
        this.retirePersonLocInfo = temp.data[0];
        const sort = [{
          field: 'lastUpdateDate',
          order: 'DESC',
        }];
        const params = new URLSearchParams();
        params.append('pageSize', '12');
        params.append('sort', JSON.stringify(sort));
        const temp2 = await axios.get(`retired-person/${result.reference.idRetired}/history`, { params });
        this.retirePersonHistInfo = temp2.data;
        if (result.reference.idMerged) {
          const mergeResults = await axios.get(`person/${result.reference.idMerged}/profile`);
          this.mergePerson = mergeResults.data;
          const temp3 = await axios.get(`person/${result.reference.idMerged}/location`);
          this.mergePersonLocInfo = temp3.data[0];
          const temp4 = await axios.get(`person/${result.reference.idMerged}/history`, { params });
          /* eslint-enable */
          this.mergePersonHistInfo = temp4.data;
        } else {
          this.mergePerson = null;
        }
      } catch (err) {
        this.loadingError = true;
      } finally {
        this.loading = false;
        this.viewConfirmationPage = false;
        this.viewDupGroupDetails = false;
        this.viewRetireMergeIdDetails = true;
      }
    },
    storeMergePerson(data) {
      this.mergePerson = data;
    },
    storeSessionFields(data) {
      this.sessionFields = data.map(a => a.code);
    },
    storeSessionResults(results) {
      this.sessionResultsStored = results.groups;
      this.personTypeSession = results.personType;
    },
    async validateData() {
      try {
        this.loadingError = false;
        if (!this.retireId) return;

        const response = await axios.get(`idmanager/validate?id=${this.retireId}`);
        // The BE returns the message already containing the ids.
        // We need to parse the strings and only get the ids.
        if (response.data.message) {
          const regex = /See Transactions?:\s*(?:[^:]+:\s*)?([\d,]+)/i;
          const match = response.data.message.match(regex);

          if (match && match[1]) {
            this.retirePendingNearMatchTransactions = match[1]
              .split(',')
              .map(id => id.trim())
              .filter(id => /^\d+$/.test(id));
          }

          if (this.retirePendingNearMatchTransactions
            && this.retirePendingNearMatchTransactions.length) {
            this.hasRetireIdMergePermission = false;
            this.hasRetireIdNoMergePermission = false;
          }
        }
      } catch (err) {
        this.loadingError = true;
      }
    },
    async viewComparePageDetails() {
      this.viewDupGroupDetails = !this.viewDupGroupDetails;
      this.viewRetireMergeIdDetails = !this.viewRetireMergeIdDetails;
      this.loading = true;
      this.loadingError = false;
      try {
        const sort = [{
          field: 'lastUpdateDate',
          order: 'DESC',
        }];
        const params = new URLSearchParams();
        params.append('sort', JSON.stringify(sort));
        const retireResults = await axios.post('person-search/by-id', {
          idType: 'statePersonId',
          id: this.retireId,
        });
        // eslint-disable-next-line prefer-destructuring
        if (retireResults.status === 200) {
          /* eslint-disable */
          this.retirePerson = retireResults.data.data[0];
          const temp = await axios.get(`person/${this.retireId}/location`);
          this.retirePersonLocInfo = temp.data[0];
          const temp2 = await axios.get(`person/${this.retireId}/history`, { params });
          this.retirePersonHistInfo = temp2.data;
          this.hasRetireIdNoMergePermission = this.hasModule('PRSID:IDENT:RETIREID');
          if (!this.hasDistrictAccess(this.retirePerson.districtCode)) {
            this.hasRetireIdNoMergePermission = false;
            this.loadingIdError = true;
            this.loadingIdErrorMsg = `User is not authorized to submit records to the specified district : ${this.retirePerson.districtCode}`;
          } else if (!this.hasSchoolAccess(this.retirePerson.schoolCode)) {
            this.hasRetireIdNoMergePermission = false;
            this.loadingIdError = true;
            this.loadingIdErrorMsg = `User is not authorized to submit records to the specified school : ${this.retirePerson.schoolCode}`;
          } else if (!this.hasPersonTypeAccess(this.retirePerson.personType)) {
            this.hasRetireIdNoMergePermission = false;
            this.loadingIdError = true;
            this.loadingIdErrorMsg = `User is not authorized to submit records to the specified person type : ${this.retirePerson.personType}`;
          }
        }
        if (this.mergeId) {
          const mergeResults = await axios.post(`person-search/by-id`, {
              idType: 'statePersonId',
              id: this.mergeId,
            });
          if (mergeResults.status === 200) {
            // eslint-disable-next-line prefer-destructuring
          this.mergePerson = mergeResults.data.data[0];
            const temp = await axios.get(`person/${this.mergeId}/location`);
            this.mergePersonLocInfo = temp.data[0];
            const temp2 = await axios.get(`person/${this.mergeId}/history`, { params });
            this.mergePersonHistInfo = temp2.data;
            /* eslint-enable */
            this.hasRetireIdMergePermission = this.hasModule('PRSID:IDENT:RETIREID');
            if (!this.hasDistrictAccess(this.mergePerson.districtCode)) {
              this.hasRetireIdMergePermission = false;
              this.loadingIdError = true;
              this.loadingIdErrorMsg = `User is not authorized to submit records to the specified district : ${this.mergePerson.districtCode}`;
            } else if (!this.hasSchoolAccess(this.mergePerson.schoolCode)) {
              this.hasRetireIdMergePermission = false;
              this.loadingIdError = true;
              this.loadingIdErrorMsg = `User is not authorized to submit records to the specified school : ${this.mergePerson.schoolCode}`;
            } else if (!this.hasPersonTypeAccess(this.mergePerson.personType)) {
              this.hasRetireIdMergePermission = false;
              this.loadingIdError = true;
              this.loadingIdErrorMsg = `User is not authorized to submit records to the specified person type : ${this.mergePerson.personType}`;
            }
          }
        }
        await this.validateData();
      } catch (err) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    hasDistrictAccess(districtCode) {
      return this.setOfUserDistricts.length === 0 || this.setOfUserDistricts.includes(districtCode);
    },
    hasSchoolAccess(schoolCode) {
      return this.setOfUserSchools.length === 0 || this.setOfUserSchools.includes(schoolCode);
    },
    hasPersonTypeAccess(personType) {
      return this.setOfUserPersonTypes.length === 0
        || this.setOfUserPersonTypes.includes(personType);
    },
  },
};
</script>

<style lang="sass" scoped>
  .column
    height: 100%
    padding: 0.5rem !important
</style>
